import { composer } from '../../../component-decorators/composer';
import { Notification } from 'wix-style-react';
import React from 'react';
export var SupportModalFailureNotification = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, show = _a.show;
    return (React.createElement(Notification, { show: show, theme: "error", type: "sticky", zIndex: 10000 },
        React.createElement(Notification.TextLabel, null, t('manage-apps.support-modal.error-notification')),
        React.createElement(Notification.CloseButton, null)));
});
//# sourceMappingURL=support-app-failure-notification.js.map